import axios from "axios";
import {ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";

export async function useContractInfo(token, type, id) {
    const contract = ref([])
    const payments = ref([])
    const pastPayments = ref([])
    const store = useStore()
    const router = useRouter()
    // ипотека/рассрочка
    let url = process.env.VUE_APP_API + 'contract.php'
    let url2 = process.env.VUE_APP_API + 'user-payments.php'
    let url3 = process.env.VUE_APP_API + 'user-past-payments.php'
    await axios
        .get(`${url}?token=${token}&section=${type}&id=${id}`)
        .then(response => (contract.value = response.data))
        .then(
            await axios
                .get(`${url2}?token=${token}&section=${type}&id=${id}`)
                .then(response => (payments.value = response.data))
        )
        .then(
            await axios
                .get(`${url3}?token=${token}&section=${type}&id=${id}`)
                .then(response => (pastPayments.value = response.data))
        )
        .catch(error => alert(error));

    //console.log(contract.value)

    if (String(contract.value['signature']) !== 'fail'){
        store.commit('contractModule/setContractInfo', contract.value)
        store.commit('contractModule/setPayments', payments.value)
        store.commit('contractModule/setPastPayments', pastPayments.value)
    } else {
        store.commit('authModule/logout')
        await router.push('/login')
    }

}